import useLocale from '../locales/useLocale';
import { COUNTRY_NAME } from '../constants/Constants';

export default function useCountry() {
  // currently implementation doesnt have difference between country and locale
  const countryCode = useLocale();
  const countryCodeInUpperCase = countryCode?.toUpperCase();

  return COUNTRY_NAME[`${countryCodeInUpperCase}`] || COUNTRY_NAME.DE;
}
